// @core/api/endpoints/apikey/update_api_key.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  APIKeyResponse,
  UpdateAPIKeyRequest,
} from '../../../types/apikey';

const BASE_PATH = '/apikey';

/**
 * Update API key
 * Updates API key configuration including name, description, scopes, permissions, and restrictions. Uses field mask for partial updates.
 */
export async function UpdateAPIKey(
  key_id: string,
  data: UpdateAPIKeyRequest,
  options?: RequestOptions
): Promise<APIKeyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/api-keys/:key_id`;
  requestPath = requestPath.replace(':key_id', encodeURIComponent(key_id));
  const requestOptions = options;
  return client.put<APIKeyResponse>(requestPath, data, requestOptions);
}
